import { useCallback, useState } from "react";

import FullScreenModal from "ds/components/FullScreenModal";
import { showSimpleLeaveConfirmation } from "ds/components/LeaveConfirmationModal/Simple";

import useCloseFullScreenModal from "../useCloseFullScreenModal";
import VCSIntegrationsManageBitbucketDataCenterForm from "./Form";

const VCSIntegrationsManageBitbucketDataCenter = () => {
  const [isDirty, setIsDirty] = useState(false);

  const { handleOnClose } = useCloseFullScreenModal();

  const modalCloseClickHandler = useCallback(async () => {
    if (isDirty) {
      await showSimpleLeaveConfirmation();
    }

    handleOnClose();
  }, [handleOnClose, isDirty]);

  const toggleIsDirty = useCallback((value: boolean) => {
    setIsDirty(value);
  }, []);

  return (
    <FullScreenModal
      title="Set up Bitbucket Data Center integration"
      onClose={modalCloseClickHandler}
    >
      <VCSIntegrationsManageBitbucketDataCenterForm onIsDirtyChange={toggleIsDirty} />
    </FullScreenModal>
  );
};

export default VCSIntegrationsManageBitbucketDataCenter;
